module.exports = __webpack_public_path__ + "static/media/iphone3-3.b15f8652.png";